/**
 * subjectParam.ts — the `:id` segment of a dossier route, as a subject.
 *
 * `parseInt('new')` IS `NaN`, AND THIS MODULE EXISTS SO NOBODY WRITES IT. One route serves both the
 * create flow and every existing subject, so the segment is a number on one of them and a word on
 * the other; a `Number()` anywhere on that path produces `NaN`, and `NaN` reaches PostgREST as
 * `loan_id=eq.NaN` — a 400 at best and a read of the wrong row at worst.
 *
 * ONE PARSER FOR EVERY DOSSIER, BECAUSE THE HAZARD IS THE ROUTE'S AND NOT THE SUBJECT'S. The advance
 * dossier reads a `loans.id` and the policy dossier reads an `insurances.id`, but both are bigserial
 * keys arriving as a URL segment an admin can hand-edit, and a second copy of these six lines is a
 * second place for `'0'` or `'1.5'` to start being accepted. `parseLoanParam` and `parsePolicyParam`
 * are the two vocabularies' own names for it and both delegate here.
 *
 * STRICT DIGITS AND POSITIVE: `'12abc'`, `'1.5'`, `'-3'`, `'0'` and `''` are all answers to a
 * question nobody asked, and each of them returns null rather than a number this app would then go
 * and query with.
 *
 * PURE, AND REACT-FREE — a leaf module with no imports of its own, so any dossier can pull it in.
 */

/** The subject a dossier's id segment names: an existing row, the create flow, or nothing. */
export type DossierSubject = number | 'new';

export function parseSubjectParam(value: string | null | undefined): DossierSubject | null {
    if (value === null || value === undefined) return null;
    const raw = value.trim();
    if (raw.toLowerCase() === 'new') return 'new';
    if (!/^\d+$/.test(raw)) return null;
    const id = Number(raw);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
}
